<mat-form-field
    appearance="outline"
    [class.ca-highlight]="highlight"
    [class.mat-form-field-invalid]="isInvalid && isTouched"
    [ngClass]="question | formFieldStyles"
    subscriptSizing="dynamic"
    [hideRequiredMarker]="question.hideRequiredMarker"
    [floatLabel]="question.floatLabel"
    class="ca-form-field ca-text-field-dropdown ca-form-field-w-full"
    [class.label-above-border]="labelAboveBorder"
>
    <mat-label *ngIf="question.label" [attr.for]="question.key">{{ question.label | translate }}</mat-label>
    <input
        matInput
        class="absolute ca-text-field-dropdown-input"
        [formControl]="textControl"
        [id]="question.key"
        [attr.data-testid]="question.key"
        [mask]="question.mask.pattern"
        [patterns]="$any(question).mask?.customPatterns"
        [decimalMarker]="$any(question).mask?.decimalMarker"
        [separatorLimit]="$any(question).mask?.separatorLimit"
        [dropSpecialCharacters]="($any(question).mask?.dropSpecialCharacters | isNil) ? true : $any(question).mask?.dropSpecialCharacters"
        (focus)="onFocus()"
    />

    <mat-select
        [formControl]="dropdownControl"
        [class]="question.key + '-test'"
        #dropdownRef
        [errorStateMatcher]="matcher"
        [disableOptionCentering]="true"
        [panelClass]="'ca-search-dropdown-panel-class ' + question.dropdownPanelClass"
        (selectionChange)="onDropdownSelect($event)"
    >
        <div *ngIf="loading; else optionsElement" class="flex justify-center items-center">
            <ca-spinner [diameter]="24" [text]="'SPINNER.LOADING' | translate"></ca-spinner>
        </div>
        <ng-template #optionsElement>
            <mat-option
                *ngFor="let option of question?.options; let index = index"
                [value]="option.key"
                [attr.data-testid]="question.key + index"
                [id]="question.key + index"
            >
                <span *ngIf="!option.customTemplate"> {{ option.key | translate }}</span>
                <ng-template vpViewHost *ngIf="option.customTemplate"></ng-template>
            </mat-option>
        </ng-template>
    </mat-select>
    <ca-icon *ngIf="highlight && !(isInvalid && isTouched)" matSuffix icon="check" class="ca-icon-s-16-p-0-f-16"></ca-icon>
    <mat-hint *ngIf="highlight && !(isInvalid && isTouched)">{{ question.conditionalHint | translate }}</mat-hint>
    <mat-error *ngIf="isInvalid && isTouched" @slideDown class="vp-subscript relative">
        <ca-form-error-message>
            {{ errorMessage | translate }}
        </ca-form-error-message>
    </mat-error>
</mat-form-field>
